export default __webpack_public_path__ + "static/media/clarinet_four.8992e329.mp3";